var _circle, _rect, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#2196F3",
    cx: 24,
    cy: 24,
    r: 21
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 22,
    fill: "#fff",
    width: 4,
    height: 11
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#fff",
    cx: 24,
    cy: 16.5,
    r: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlue);
export default __webpack_public_path__ + "static/media/info_blue.89617bdabb351adbff5826fbcdf2b511.svg";
export { ForwardRef as ReactComponent };